export default __webpack_public_path__ + "static/media/amazon.40d4de4f.png";